import Dropdown from "@stimulus-components/dropdown";

export default class extends Dropdown {
}
